export const DISCORD_URL = "https://discord.gg/XW4pUjBjad";
export const WIKI_URL = "https://wiki.draconia.cz";
